import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { environment } from '../../../environments/environment';
import { catchError, from, switchMap, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  public auth = inject(AuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    // only attach the token to requests targeting the configured API
    if (!req.url.startsWith(environment.apiUrl)) {
      return next.handle(req);
    }

    if (!this.auth.getActiveAccount()) {
      return next.handle(req);
    }

    return from(this.auth.getToken()).pipe(
      switchMap((token) => {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next.handle(authReq).pipe(
          catchError((error) => {
            if (error.status === 401 && !req.headers.has('x-retry')) {
              return this.retryWithRefresh(req, next);
            }

            return throwError(() => error);
          }),
        );
      }),
    );
  }

  private retryWithRefresh(req: HttpRequest<unknown>, next: HttpHandler) {
    return from(this.auth.getToken(true)).pipe(
      switchMap((token) => {
        const retryReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'x-retry': 'true',
          },
        });

        return next.handle(retryReq);
      }),
      catchError((err) => {
        console.error('Final auth failure', err);
        return throwError(() => err);
      }),
    );
  }
}
